import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import GroupIcon from "@material-ui/icons/Group";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import FeedbackIcon from "@material-ui/icons/Feedback";
import TextsmsIcon from "@material-ui/icons/Textsms";
import CategoryIcon from "@material-ui/icons/Category";

import { useStyles } from "./MenuDrawer.css";

class MenuDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [
        {
          name: "Dashboard",
          value: false,
          icon: <DashboardRoundedIcon />,
          subMenu: [
            {
              name: "Dashboard",
              url: "/_administration_/dashboard",
            },
          ],
        },
        {
          name: "Users",
          value: false,
          icon: <GroupIcon />,
          subMenu: [
            {
              name: "View Users",
              url: "/_administration_/user/view",
            },
          ],
        },
        {
          name: "Author",
          value: false,
          icon: <PersonRoundedIcon />,
          subMenu: [
            {
              name: "Add Author",
              url: "/_administration_/author/add",
            },
            {
              name: "View Author",
              url: "/_administration_/author/view",
            },
          ],
        },
        {
          name: "Book Category",
          value: false,
          icon: <CategoryIcon />,
          subMenu: [
            {
              name: "Add Book Category",
              url: "/_administration_/category/add",
            },
            {
              name: "View Book Category",
              url: "/_administration_/category/view",
            },
          ],
        },
        {
          name: "Books",
          value: false,
          icon: <MenuBookIcon />,
          subMenu: [
            {
              name: "Add Book",
              url: "/_administration_/book/add",
            },
            {
              name: "Unapproved Books",
              url: "/_administration_/books/unapproved",
            },
            {
              name: "Approved Books",
              url: "/_administration_/books/approved",
            },
            {
              name: "View Books",
              url: "/_administration_/book/view",
            },
          ],
        },
        {
          name: "Message",
          value: false,
          icon: <TextsmsIcon />,
          subMenu: [
            {
              name: "View Messages",
              url: "/_administration_/messages/view",
            },
          ],
        },
        {
          name: "Feedback",
          value: false,
          icon: <FeedbackIcon />,
          subMenu: [
            {
              name: "View Feedbacks",
              url: "/_administration_/feedback/view",
            },
          ],
        },
      ],
    };
  }

  handleOpen = (name) => {
    const newArray = this.state.menu.map((item) =>
      item.name === name
        ? { ...item, value: !item.value }
        : { ...item, value: false }
    );
    this.setState({
      menu: newArray,
    });
  };

  handler = (children) => {
    return children.map((menu, index) => {
      if (!menu.subMenu) {
        return (
          <div key={index}>
            <ListItem
              button
              style={{ display: "flex", flexDirection: "row", paddingLeft: 30 }}
            >
              <Brightness1Icon className={this.props.classes.iconStyle} />
              <ListItemText>
                <Link to={menu.url} className={this.props.classes.sublist}>
                  <Typography
                    style={{ outline: "none", padding: 5, fontSize: 15 }}
                  >
                    {menu.name}
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
          </div>
        );
      } else {
        return (
          <div key={index}>
            <ListItem
              button
              style={{ display: "flex", flexDirection: "row" }}
              onClick={() => this.handleOpen(menu.name)}
            >
              {menu.icon}
              <ListItemText>
                <Typography
                  style={{ outline: "none", padding: 5, fontSize: 15 }}
                >
                  {menu.name}
                </Typography>
              </ListItemText>
              {menu.value ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={menu.value} timeout="auto" unmountOnExit>
              {this.handler(menu.subMenu)}
            </Collapse>
          </div>
        );
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <List>{this.handler(this.state.menu)}</List>
      </div>
    );
  }
}

export default withStyles(useStyles)(MenuDrawer);
